import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { snakeToCamel } from "caseparser";

export const reasonsApi = api
  .enhanceEndpoints({ addTagTypes: ["installations"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      installations: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/installations`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["installations"],
      }),
    }),
  });

export const {
  useInstallationsQuery,
} = reasonsApi;
